/*
 * This file is part of glowingblue/gamilytics.
 *
 * Copyright (c) 2023 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import Model from 'flarum/common/Model';

export default class AchievementLevel extends Model {
	id = Model.attribute('id');
	level = Model.attribute('level');
	points = Model.attribute('points');
	name = Model.attribute('name');
	icon = Model.attribute('icon');
	image = Model.attribute('image');
	description = Model.attribute('description');
	backgroundColor = Model.attribute('backgroundColor');
	iconColor = Model.attribute('iconColor');
	levelBgColor = Model.attribute('levelBgColor');
	levelTextColor = Model.attribute('levelTextColor');
	userCount = Model.attribute('userCount');
	createdAt = Model.attribute('createdAt');

	achievement = Model.hasOne('achievement');
	users = Model.hasMany('users');
	lastUsers = Model.hasMany('lastUsers');
	trigger = Model.attribute('trigger');
}
